import { NgModule, LOCALE_ID } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import localePT from '@angular/common/locales/pt';
import localeExtraPT from '@angular/common/locales/extra/pt';

import { TooltipModule } from 'primeng/tooltip';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TimelineModule } from 'primeng/timeline';
import { DashboardEventoVendasComponent } from './dashboard-evento-vendas/dashboard-evento-vendas.component';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { MultiSelectModule } from 'primeng/multiselect';

import { PainelModule } from 'src/app/shared/components/painel/painel.module';
import { ChartModule } from 'primeng/chart';
import { DialogModule } from 'primeng/dialog';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DashboardEventoVendasDetalheComponent } from './dashboard-evento-vendas-detalhe/dashboard-evento-vendas-detalhe.component';

registerLocaleData(localePT, 'pt', localeExtraPT);
@NgModule({
  providers: [{provide: LOCALE_ID, useValue: 'pt-BR'}],
  declarations: [DashboardEventoVendasComponent, DashboardEventoVendasDetalheComponent],
  imports: [
    
  TooltipModule,
    CommonModule,
    FormsModule,
    TableModule,
    ButtonModule,
    BrowserModule,
    ToastModule,
    SelectButtonModule ,
    PainelModule,    
    TimelineModule,
    ToggleButtonModule,
    MultiSelectModule,
    ChartModule,
    DialogModule,
    ConfirmDialogModule,
  ],
  exports: [DashboardEventoVendasComponent]
})
export class DashboardModule { }